import { render } from "./donut-onboarding.vue?vue&type=template&id=f1fce9b0&lang=pug"
import script from "./donut-onboarding.vue?vue&type=script&lang=js"
export * from "./donut-onboarding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__